import "@/common/debug";

import { IGameCell, IGameData, ISoftData, IAdData } from "@/common/interface";
import { message } from "@/components/common/Message";
import { Rank } from "@/components/common/Rank";
import Banner from "@/components/game/Banner";
import ScreenAd from "@/components/common/ScreenAd";
import Nav from "@/components/game/Nav";
import Schedule from "@/components/game/Schedule";
import Special from "@/components/game/Special";
import { asyncGetGameData, IGameState, store } from "@/store/game";
import "@/styles/game.scss";
import React, { useEffect } from "react";
import { render } from "react-dom";
import { Helmet } from "react-helmet";
import { connect, Provider } from "react-redux";
import { registerMonitor } from "@/common/selfMonitor";
import { greaterVersion, urlToObject } from "@/utils/helper";
import { resetOldMonitor, registerMonitorV2 } from "@/common/selfMonitor";

// import "@/common/debug";
resetOldMonitor();
registerMonitorV2("QH_780_1732", true);

const NEW_GAME_VERSION = "7.5.0.1560";
const { ver: CURRENT_VERSION } = urlToObject();
const SHOW_NAV = greaterVersion(CURRENT_VERSION, NEW_GAME_VERSION);

registerMonitor("QH_132_6", true);
interface IProps {
  hotList: IGameData["hotList"];
  heatList: IGameData["heatList"];
  network: IGameData["network"];
  pageGame: IGameData["pageGame"];
  ad: IAdData;
  // standAlone: IGameData["standAlone"];
  onGetGameData: () => Promise<any>;
}

const data2SoftInfo = (data: IGameCell[]) =>
  data.reduce((arr, item) => {
    const {
      soft_id,
      name,
      title,
      down_num,
      pic_href,
      new_recommend_pic_href,
      icon_pic,
      href_type,
    } = item;
    return [
      ...arr,
      {
        soft_id,
        name: title || name,
        downloadnum: down_num,
        href: pic_href,
        openType: href_type,
        icon: new_recommend_pic_href || icon_pic,
      },
    ];
  }, [] as ISoftData[]);

const Game: React.FC<IProps> = ({
  onGetGameData,
  heatList,
  network,
  // standAlone,
  pageGame,
  ad,
}) => {
  useEffect(() => {
    onGetGameData().catch((e) => {
      message.show({
        type: "error",
        content: e.message,
      });
    });
  }, [onGetGameData]);

  return (
    <div className="wrap">
      <Helmet title="游戏精选 - 360软件管家" />
      {SHOW_NAV && <Nav current="index" />}
      <div className="main">
        <Banner />
        <Schedule position="gamedatatop" />
        <div className="area clearfix">
          <Rank
            className="game-rank"
            data={data2SoftInfo(heatList)}
            title="热度排行榜"
            position="gameheadlist"
            loading={!(heatList && heatList.length)}
          />
          <Special
            className="landscape-special"
            data={network}
            title="网络游戏"
            position="gamenetwork"
          />
          {/* <Special
            className="portrait-special"
            data={standAlone}
            title="单机游戏"
          /> */}
          <Special
            className="landscape-special"
            data={pageGame}
            title="网页游戏"
            position="gamepagegame"
          />
          <ScreenAd data={ad} position="gameadvertising" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  gameData: { hotList, heatList, network, pageGame, advertising },
}: IGameState) => {
  const adOriginData =
    advertising && advertising.length ? advertising[0] : ({} as IGameCell);

  const ad = Object.assign(adOriginData, {
    url: adOriginData.openScreenAd_pic_href,
    ad_id: adOriginData.unique,
    startTime: adOriginData.openScreenAd_start_time,
    endTime: adOriginData.openScreenAd_time,
  }) as unknown as IAdData;
  return {
    hotList,
    heatList,
    network,
    pageGame,
    ad,
  };
};

const mapDispatchToProps = {
  onGetGameData: asyncGetGameData,
};

const ConnectGame = connect(mapStateToProps, mapDispatchToProps)(Game);

render(
  <Provider store={store}>
    <ConnectGame />
  </Provider>,
  document.getElementById("app"),
);
